/**
 * Browser device id for the new-account abuse rules (api signup_signals).
 *
 * A random UUID, mirrored to localStorage and a first-party cookie so clearing
 * one keeps the other. Sent only as the X-Heyward-Device header on the
 * ComplianceGate's /eligibility/me call; the backend stores a keyed hash of it,
 * never the id itself. Not a fingerprint — it is derived from nothing about the
 * browser, and private windows get a fresh one.
 */

const KEY = 'heyward_device_id';
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
const COOKIE_MAX_AGE = 60 * 60 * 24 * 400; // browsers cap cookie lifetime at 400 days

function readCookie() {
  const m = document.cookie.match(new RegExp(`(?:^|; )${KEY}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : null;
}

function newId() {
  if (crypto?.randomUUID) return crypto.randomUUID();
  const b = crypto.getRandomValues(new Uint8Array(16));
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = [...b].map((x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

export function getDeviceId() {
  let stored = null;
  try { stored = localStorage.getItem(KEY); } catch { /* storage blocked: cookie still works */ }
  const id = [stored, readCookie()].find((v) => v && UUID_RE.test(v)) || newId();
  try { localStorage.setItem(KEY, id); } catch { /* storage blocked: cookie still works */ }
  document.cookie = `${KEY}=${encodeURIComponent(id)}; Max-Age=${COOKIE_MAX_AGE}; Path=/; SameSite=Lax; Secure`;
  return id;
}
